import { inject } from "aurelia-framework";

@inject()
export class CookieConsent {
    private hasAcceptedCookies: boolean;

    private constructor() {
        this.hasAcceptedCookies = localStorage.getItem("cookiesAccepted") === "true";
    }

    protected get showPopup(): boolean {
        return !this.hasAcceptedCookies;
    }

    protected acceptCookies() {
        this.hasAcceptedCookies = true;
        localStorage.setItem("cookiesAccepted", "true");
    }
}
